import React from 'react'
import { Select, Input } from "antd"

const FilterInput = ({ options, onChange, placeholder, type, field, showSearch, value }) => {

    const _handleChangeSelect = value => {
        onChange(field, value)
    }

    const _handleChangeSearch = e => {
        const { value } = e.target
        onChange(field, value)
    }

    return (
        type === 'select' ?
            <div className='FilterSelect'>
                <Select
                    onChange={_handleChangeSelect}
                    style={{ minWidth: field === 'status' ? "70%" : "100%" }}
                    allowClear
                    placeholder={placeholder}
                    options={options}
                    showSearch={showSearch}
                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                    value={value}
                />
            </div> :
            <div className='FilterSearch'>
                <Input
                    placeholder={placeholder}
                    style={{ minWidth: "100%" }}
                    onChange={_handleChangeSearch}
                    allowClear
                />
            </div>
    )
}

export default FilterInput